// removed by extract-text-webpack-plugin
module.exports = {"mainDiv":"_1QwfvQNidHdEPtUz8ERW3L","mainImg":"_3I8SZCMmFjP684iZqJUi7o","title":"_1DdJZN9xcLdtXZIJBbGnTW","text":"_2IFOrQK_d-9hEA-3UfM_cI","spacer":"o65tdtLNhJtfI51bGqQQ-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Contact/Contact.css
// module id = 48
// module chunks = 0